import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider, Grid, CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';
import productsData from '../jsons/products.json'; // Import your JSON data
import ProductCard from '../components/ProductCard'; // Assuming you have a ProductCard component

const SearchResults = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchTerm = queryParams.get('q');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (searchTerm) {
      fetchSearchResults(searchTerm);
    }
  }, [searchTerm]);

  const fetchSearchResults = (term) => {
    setLoading(true);
    // Simulate fetching from a backend or filter locally from JSON data
    const filteredProducts = productsData.filter(product =>
      product.title.toLowerCase().includes(term.toLowerCase())
    );
    setSearchResults(filteredProducts);
    setLoading(false);
  };

  return (
    <Box sx={{ display: 'flex', backgroundColor: '#eef2f6', pt: 2 }}>
      <Box sx={{ width: '100%', pl: 2 }}>
        <Typography variant="h5" component="h2">
          Search Results for "{searchTerm}"
        </Typography>
        <Divider sx={{ mb: 2 }} />
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <CircularProgress />
          </Box>
        )}
        {!loading && searchResults.length === 0 && (
          <Typography variant="body1">
            No results found for "{searchTerm}"
          </Typography>
        )}
        {!loading && searchResults.length > 0 && (
          <Grid container spacing={2}>
            {searchResults.map((product) => (
              <Grid item key={product.id} xs={12} sm={6} md={4} lg={3}>
                <ProductCard product={product} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default SearchResults;
